import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("decorators");


// export function deprecated(issue: string = "", message: string = "") {
//
//     //fixme  this loses reference to "this" if the originalDescriptor - find solution with bind ?
//     return function (target: any, propertyName: string, descriptor: TypedPropertyDescriptor<(...args) => any>) {
//         const originalDescriptor = descriptor.value;
//
//         descriptor.value = (...args) => {
//             logger.warn(`${propertyName} IS DEPRECATED. ${addIssue(issue)}${addMessage(message)}`);
//             originalDescriptor(args);
//         }
//         return descriptor;
//
//     }
// }
export function commentedOut(issue: string = "", message: string = "") {

    return function (target: any, propertyName: string, descriptor: TypedPropertyDescriptor<(...args) => any>) {
        descriptor.value = () => logger.warn(`${propertyName} was commented out. ${addIssue(issue)}${addMessage(message)}`);
        return descriptor;

    }
}



function addIssue(issue: string = ""): string {
    return (issue !== "") ? ` IssueID: ${issue} ` : "";
}
function addMessage(message: string = ""): string {
    return (message !== "") ? ` message: ${message} ` : "";
}

export function replacedWith(replacement: ReplacementFunction) {

    return function (target: any, propertyName: string, descriptor: TypedPropertyDescriptor<(...args) => any>) {
        // console.warn(`${propertyName} was replaced! by ${replacement}` );
        descriptor.value = replacement;
        return descriptor;

    }
}


export interface ReplacementFunction {
    (args?: any): any;
}

/**
 *  This class decorator exports the class instance to window, instances are stored in a map, whose name is defined in `groupName`, the key is the class name.
 *  ```javascript
 *  @exportToWindow() // or use exportToWindow("global")
 *  class A {}
 *
 *  class B extends A {} // any class extends A will be automatically exported to window
 *
 *  let a = new A(); // then `window.global.get("A")` will get `a`
 *  let b = new B(); // then `window.global.get("B")` will get `b`
 *  ```
 *
 *  Known issue:
 *  1. If the class is instantiated more then once, the latter instance overrides the previous one
 *  2. TODO impletement `destroyFunctionName` functionality
 * @param groupName the map object name in window
 * @param destroyFunctionName the function name in the class that deleting the instance
 */
export function exportToWindow(groupName = "global", destroyFunctionName?: string) {
    return function <T extends { new (...args: any[]): {} }>(originConstructor: T): typeof originConstructor {
        class ExportToWindowDebuggerClass extends originConstructor {
            private _exportedClassName: string;
            constructor(...args) {
                super(...args);
                let exported = window[groupName] = window[groupName] || new Map();
                this._exportedClassName = this.constructor.name === "ExportToWindowDebuggerClass" ? originConstructor.name : this.constructor.name;
                exported.set(this._exportedClassName, this);
            }
        }
        ExportToWindowDebuggerClass.prototype = originConstructor.prototype;
        return ExportToWindowDebuggerClass;
    };
}
